/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  LeverageGetInterestRateOptions,
  LeverageGetInterestRateResponses,
} from '../types/LeverageGetInterestRate'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get leverage borrowing and lending yields for a specific asset
 * {@link /v1/leverage/interest_rate/:asset_id}
 */
export function leverageGetInterestRate<ThrowOnError extends boolean = true>(
  options: Options<LeverageGetInterestRateOptions, ThrowOnError>,
): Unwrappable<RequestResult<LeverageGetInterestRateResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/leverage/interest_rate/{asset_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<LeverageGetInterestRateResponses, ThrowOnError>>,
  )
}
